import { EventEmitter } from 'events';

import { trim } from 'lodash-es';
import { customAlphabet, nanoid } from 'nanoid';
import queryString from 'query-string';

import { getChecksumAddress } from 'starknet';

import { SIGN_ROLE_ENUM } from '@/constants';
import { IContact, ICurrentUser, IOption } from '@/types';

import { getNetworkByAddress } from './chain';

export const getNaNoId = (size?: number): string => {
  return nanoid(size);
};

export const getNanoidEn = (size?: number): string => {
  const nanoid = customAlphabet('abcdefghijklmnopqrstuvwxyz', size);
  return nanoid();
};

export const getCustomNaNoId = (): string => {
  const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 10);
  return nanoid();
};

export const getOptionsByEnum = (enumObj: Record<string, string>): IOption[] => {
  return Object.keys(enumObj).map((key) => {
    return {
      label: enumObj[key],
      value: key
    };
  });
};

export const isSameUser = (a: ICurrentUser, b: ICurrentUser): boolean => {
  const isStarknet = a.chainType === 'starknet' || b.chainType === 'starknet';
  let addressA = a.address?.toLowerCase() || a.walletAddress?.toLowerCase();
  let addressB = b.address?.toLowerCase() || b.walletAddress?.toLowerCase();
  if (isStarknet) {
    try {
      addressA = addressA && getChecksumAddress(addressA);
      addressB = addressB && getChecksumAddress(addressB);
    } catch (error) {
      console.log('');
    }
  }
  if (addressA && addressB) {
    return (
      addressA === addressB ||
      addressA === b.displayAddress?.toLowerCase() ||
      addressB === a.displayAddress?.toLowerCase()
    );
  }
  if (a.email && b.email && !addressA && !addressB) {
    return a.email === b.email;
  }
  return false;
};

export const decodeEmail = (email: string): string => {
  if (!email) return '';
  let result = '';
  try {
    result = window.atob(decodeURIComponent(email));
  } catch (error) {
    result = '';
  }
  return result;
};

export const stringifyQueryString = (obj: Record<string, any>): string => {
  return queryString.stringify(obj, { skipNull: true, skipEmptyString: true });
};

export const parseQuery = (params: string): Record<string, any> => {
  return queryString.parse(params);
};

// safeParseJSON
export const safeParseJSON = (str: string): any => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return null;
  }
};

export const isServer = (): boolean => typeof window === 'undefined';

export const globalEventBus = new EventEmitter();

export const getSignerByInputValue = (val: string): Partial<IContact> & { status?: string } => {
  const v = trim(val);
  if (v.includes('@')) {
    return {
      email: v,
      status: 'add',
      role: SIGN_ROLE_ENUM.SIGNER,
      name: v.split('@')[0]
    };
  } else {
    // 没有network则为非法地址
    const network = getNetworkByAddress(v);
    return network
      ? {
          walletAddress: v,
          status: 'add',
          network: network
        }
      : {
          walletAddress: v,
          status: 'error',
          network: network
        };
  }
};
